import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { FormattedMessage, FormattedHTMLMessage, injectIntl } from 'react-intl';

import Footer from 'components/Footer';
import Header from 'components/Header';
import SignUpSection from 'components/SignUpSection';
import TopBanner from 'components/TopBanner';
import Heading from 'components/Heading';
import { FONT_FAMILIES, FONT_SIZES, SPACE, COLOR } from 'config';
import Container from 'components/Container';
import { rem } from 'polished';
import styled from 'styled-components';
import media from 'utils/media';

import bg from '../press_releases.svg';

const SM_FONT_SIZE = 11;

const StyledContainer = styled(Container)`
  margin-bottom: ${rem(SPACE[9])};
`;

const StyledHeading = styled(Heading)`
 
`;

const StyledContent = styled.div`
  font-family: ${FONT_FAMILIES.sans};
  line-height: 34px;
  padding: 20px 0 20px 0;
  font-size:${rem(SM_FONT_SIZE)};

  ${media.sm.css`
    flex-direction: row;
    font-size:${rem(FONT_SIZES[2])};
  `}

  strong {
    font-family: ${FONT_FAMILIES.sansBold};
    line-height: 34px;
    padding: 20px 0 20px 0;
    font-size:${rem(SM_FONT_SIZE)};

    ${media.sm.css`
      flex-direction: row;
      font-size:${rem(FONT_SIZES[2])};
    `}
  }
`;

const Release = ({ intl }) => (
  <div>
    <Helmet>
      <title>{intl.formatMessage({ id: 'pressreleases.releases.title' })}</title>
      <meta
        name="description"
        content={intl.formatMessage({ id: 'pressreleases.releases.description' })}
      />
    </Helmet>
    <Header />
    <TopBanner src={bg} />
    <StyledContainer>
      <StyledHeading heavy as="h1" fontSize={[6, 7]} color={COLOR.textDark} mb={2}>
        <FormattedMessage id="pressreleases.releases.title" />
      </StyledHeading>
      <StyledContent>
        <FormattedHTMLMessage id="pressreleases.releases.content.description" />
      </StyledContent>
    </StyledContainer>
    <SignUpSection />
    <Footer />
  </div>
);

Release.propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
};

export default injectIntl(Release);



// WEBPACK FOOTER //
// ./src/components/PressReleases/Release/Release.js